import { Loader2, ShieldCheck, type LucideIcon } from 'lucide-react'
import type { BlockLockReason } from './useBlocksInRun'
import { messagesNow } from '@/i18n'
import { messages } from './messages'

export interface LockReasonText {
  /** Плашка вместо редактора блока (`BlockRunNotice`). */
  notice: string
  /** Тултип погашенных «Сохранить»/«Удалить» в шапке панели. */
  headerTitle: string
  /** Чип поверх миниатюры. */
  chip: string
  /** Тултип погашенной корзины миниатюры. */
  thumbTitle: string
  icon: LucideIcon
  /** Крутить иконку: у прогона идёт работа, у проверки — ожидание решения. */
  spin: boolean
}

/**
 * Единый словарь причин лока блока. `Record` по `BlockLockReason` исчерпывающий:
 * новая причина не соберётся, пока ей не написаны все тексты. Глагол честный —
 * у перевода список блоков неизвестен (§7.5), и «переписывается» соврало бы;
 * у проверки прогона нет вовсе, заперто решением модерации.
 */
/** Тексты читаются геттерами в момент обращения — язык интерфейса может смениться
 *  после загрузки модуля. Компонент-читатель подписывается на язык сам. */
const entry = (reason: BlockLockReason, icon: LucideIcon, spin: boolean): LockReasonText => ({
  get notice() {
    return messagesNow(messages)[`${reason}Notice`]
  },
  get headerTitle() {
    return messagesNow(messages)[`${reason}HeaderTitle`]
  },
  get chip() {
    return messagesNow(messages)[`${reason}Chip`]
  },
  get thumbTitle() {
    return messagesNow(messages)[`${reason}ThumbTitle`]
  },
  icon,
  spin,
})

export const LOCK_REASON_TEXT: Readonly<Record<BlockLockReason, LockReasonText>> = {
  edit: entry('edit', Loader2, true),
  translation: entry('translation', Loader2, true),
  review: entry('review', ShieldCheck, false),
}
